/* IKIDO Engraving menu add-on: image panel in the desktop mega menu and mobile drawer,
   New badge, and the #design / #bulk-quote anchors on the studio page. */
(function () {
  'use strict';
  function badge() {
    var b = document.createElement('span');
    b.className = 'en-badge';
    b.textContent = 'New';
    return b;
  }
  function desktop() {
    var tpl = document.getElementById('EngravingMegaPanel');
    if (!tpl) return;
    var handle = tpl.getAttribute('data-handle');
    var summary = document.getElementById('HeaderMenu-' + handle);
    if (!summary) return;
    var details = summary.closest('details');
    if (details && !details.querySelector('.en-panel')) {
      var content = details.querySelector('.mega-menu__content, .header__submenu');
      if (content && content.classList.contains('mega-menu__content')) {
        details.classList.add('mega-menu--engraving');
        var list = content.querySelector('.mega-menu__list');
        var panel = tpl.content.cloneNode(true);
        if (list) content.replaceChild(panel, list); else content.appendChild(panel);
      }
    }
    if (tpl.getAttribute('data-badge') !== 'false' && !summary.querySelector('.en-badge')) {
      var title = summary.querySelector('span');
      if (title && title.nextSibling) summary.insertBefore(badge(), title.nextSibling);
      else summary.appendChild(badge());
    }
  }
  function drawer() {
    var tpl = document.getElementById('EngravingDrawerPanel');
    if (!tpl) return;
    var handle = tpl.getAttribute('data-handle');
    var sub = document.getElementById('link-' + handle);
    if (sub && !sub.querySelector('.en-panel')) {
      var inner = sub.querySelector('.menu-drawer__inner-submenu') || sub;
      var list = inner.querySelector('.menu-drawer__menu');
      var panel = tpl.content.cloneNode(true);
      if (list) { list.classList.add('en-drawer-list'); inner.insertBefore(panel, list); }
      else inner.appendChild(panel);
    }
    var summary = document.getElementById('HeaderDrawer-' + handle);
    if (summary && tpl.getAttribute('data-badge') !== 'false' && !summary.querySelector('.en-badge')) {
      var icon = summary.querySelector('.svg-wrapper, svg');
      summary.insertBefore(badge(), icon);
    }
  }
  function anchors() {
    var map = { design: '.es-studio', 'bulk-quote': '.es-quote' };
    Object.keys(map).forEach(function (id) {
      var el = document.querySelector(map[id]);
      if (!el || document.getElementById(id)) return;
      var a = document.createElement('div');
      a.className = 'es-anchor'; a.id = id;
      el.insertBefore(a, el.firstChild);
    });
    var h = (location.hash || '').slice(1);
    if (map[h] && document.getElementById(h)) {
      var go = function () { document.getElementById(h).scrollIntoView(); };
      setTimeout(go, 60);
      if (document.readyState !== 'complete') window.addEventListener('load', function () { setTimeout(go, 50); });
    }
  }
  function run() { desktop(); drawer(); }
  function boot() { run(); anchors(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', run);
})();
